import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import InformationFrame from "../../../common/components/InfomationFrame/InformationFrame";
import { useAppDispatch } from "../../../common/state/hooks";
import { getPublishWarningText } from "../../alert/state/alertsSlice";
import {
  getCurrentProjectGroupBuilds,
  resetNewPublicationState,
} from "../../builds/state/buildsSlice";
import PublishNewVersion from "./PublishNewVersion";
import PublishWhileThereIsAnExistingBuild from "./PublishWhileThereIsAnExistingBuild";
import { Outlet, useLocation } from "react-router-dom";

export default function AskPublicationWrapper() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const path = location.pathname.split("/");
  const lastUrlElement = path[path.length - 1];

  const currentProjectGroupBuilds = useSelector(getCurrentProjectGroupBuilds);
  const publishWarningText = useSelector(getPublishWarningText);

  // Reset publication state when entering publication flow (handles direct URL navigation)
  useEffect(() => {
    dispatch(resetNewPublicationState());
  }, [dispatch]);

  const smartTitle = location.pathname.includes("publish/new/platforms")
    ? t("pages.projectGroup.publish.sameVersion")
    : location.pathname.includes("publish/new/version")
    ? t("pages.projectGroup.publish.newVersion")
    : "";

  return (
    <div className="flex flex-col align-center items-center h-full">
      {publishWarningText ? (
        <InformationFrame
          className="w-full px-6 max-w-6xl mx-auto z-50 transition-opacity z-[100]"
          style="warning"
          withTimeout={false}
          showCloseButton={false}
        >
          <span>{publishWarningText}</span>
        </InformationFrame>
      ) : null}
      <h2 className="mx-4 font-medium text-2xl">
        {`${t("pages.projectGroup.publish.newPublication")} ${smartTitle}`}
      </h2>
      <Outlet />
      {lastUrlElement === "new" &&
        (currentProjectGroupBuilds.length === 0 ? (
          <PublishNewVersion />
        ) : (
          <PublishWhileThereIsAnExistingBuild />
        ))}
    </div>
  );
}
